module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas-animation",
    class: {
      hide: !_vm.isCanvasVisible, home: _vm.isHome
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3371a01a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Canvas.vue
// module id = 286
// module chunks = 0